// extracted by mini-css-extract-plugin
export var messageSideLeft = "_sr-1";
export var stateContainer = "_sr-0";